import { render, staticRenderFns } from "./Flows.vue?vue&type=template&id=dc25299c&scoped=true&"
import script from "./Flows.vue?vue&type=script&lang=ts&"
export * from "./Flows.vue?vue&type=script&lang=ts&"
import style0 from "./Flows.vue?vue&type=style&index=0&id=dc25299c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc25299c",
  null
  
)

export default component.exports